// Typed access to tips.json
// eslint-disable-next-line @typescript-eslint/no-var-requires
const data = require('./tips.json') as { tips: string[] }

export const tips: string[] = Array.isArray(data.tips) ? data.tips : []

export const pickRandom = (list: string[], rng: () => number = Math.random): string | null => {
  if (!Array.isArray(list) || list.length === 0) {
    return null
  }
  const idx = Math.floor(rng() * list.length)
  return list[idx] ?? null
}
